export default __webpack_public_path__ + "static/media/property_1004.579425bf.png";